import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/Header.scss';
import logo from '../assets/icons/logo-white.svg';
import stickyLogo from '../assets/icons/logo-blue.svg';
import menuBlue from '../assets/icons/menu-blue.svg';
import menuWhite from '../assets/icons/menu-white.svg';

class Header extends React.Component {

    state = {
        sticky: false,
        activeClass: ''
    }
    btnclose = (e) => {
        e.preventDefault();
        document.getElementById('side-menu').style.width = '0px';

    }


    btnclick = () => {
        document.getElementById('side-menu').style.width = '200px';
    }

    componentDidMount() {
        let classSticky;
        let _this = this;
        let head = document.getElementById('header');//dom element

        window.onscroll = function () { //on scroll event
            let sticky = head.offsetTop;
            if (window.pageYOffset > sticky) {

                classSticky = 'down';

            } else {
                classSticky = '';
            }
            _this.setState({
                activeClass: classSticky,
            })
        }


    }


    render() {
        return (

        <React.Fragment>
            <header id="header" className={`clone ${this.state.activeClass} `}>
                <div className="header-container">
                        <Link to="/" id="logo"><img className="blueLogo" src={stickyLogo} alt="blue-logo"/></Link>

                    <span id="open-slide" style={{cursor: 'pointer'}} onClick={this.btnclick}>
                         <img src={menuBlue} className="menu" alt="hamburger"/> </span>
                    <nav className="list">
                        <ul className="quick-links ">
                            <li className="list-wrapper"><Link to="/" className="links">Home</Link></li>
                            <li className="list-wrapper"><Link to="/about" className="links">About Us</Link></li>
                            <li className="list-wrapper"><Link to="/contact-us" className="links"> Contact Us</Link></li>
                            <li  className="btn-bg list-wrapper"><a href="https://lawshram.com/login" className="login"> Login</a>
                            </li>
                        </ul>

                    </nav>

                </div>
            </header>


            <header id="header" >
                <div className="header-container">
                {this.state.activeClass ?
                    <Link to="/" id="logo"><img className="blueLogo" src={stickyLogo} alt="blue logo"/></Link> :
                    <Link to="/" id="logo"><img className="whiteLogo" src={logo} alt="white logo"/></Link>}


                <span id="open-slide" style={{cursor: 'pointer'}} onClick={this.btnclick}>
                         <img src={menuWhite} className="menu" alt="hamburger"/></span>
                <nav className="list">
                    <ul className="quick-links ">
                        <li className="list-wrapper"><Link to="/" className="links">Home</Link></li>
                        <li className="list-wrapper"><Link to="/about" className="links">About Us</Link></li>
                        <li className="list-wrapper"><Link to="/contact-us" className="links"> Contact Us</Link></li>
                        <li className="btn-bg list-wrapper"><a href="https://lawshram.com/login" className="login"> Login</a>
                        </li>
                    </ul>

                </nav>
                    {/*responsive sidebar markup*/}
                    <div id="side-menu" className="side-nav">
                        <a href=" " className="btn-close" onClick={this.btnclose}>&times;</a>
                        <div className="links-wrapper">
                            <div onClick={this.btnclose}><Link to="/" >Home</Link></div>
                            <div onClick={this.btnclose}><Link to="/about" >About us</Link></div>
                            <div onClick={this.btnclose}><Link to="/contact-us" > Contact us</Link></div>
                            <a href="https://lawshram.com/login" className="login-responsive">Login</a>
                        </div>

                    </div>
                </div>
            </header>
        </React.Fragment>
    )
    }
}

export default Header;